import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent, InputComponent, WaitButtonComponent } from '@sircon/sircon-ui-framework';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
    selector: 'app-lost-account-id',
    templateUrl: './lost-account-id.component.html',
    imports: [FormsModule, ReactiveFormsModule, InputComponent, WaitButtonComponent]
})
export class LostAccountIdComponent extends BaseComponent {

    @Output() workflowEvent = new EventEmitter();
    @Output() previousStep = new EventEmitter();
    @Input() submitting = false;

    @Input() errors;
    @Output() errorsChange = new EventEmitter;

    lostAccountIdForm: FormGroup;

    constructor(private formBuilder: FormBuilder) {
        super();
        this.lostAccountIdForm = this.formBuilder.group({
            emailAddress: ['', [Validators.required, Validators.email]]
        });
    }

    submit() {
        this.workflowEvent.emit({ emailAddress: this.lostAccountIdForm.value.emailAddress });
    }

    back() {
        this.previousStep.emit();
    }
}
